function metrics() {
	const elId = '#app-metrics';
	const elClass = '.js-vue-metrics';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const app = new Vue({
		el: elId,
		data: {
			res: null,
			error: null,
			metrics: {
				title: 'Gemmidelde Uitgaven',
				data: null
			}
		},
		created: function() {
			this.getDataFromAPI();
		},
		mounted: function() {
			$(elClass).removeClass('is-mounting');
		},
		methods: {
			getDataFromAPI: function() {
				const self = this;
				const url = '/static/metrics-data.json';

				GET(url)
					.then(xhr => {
						const response = JSON.parse(xhr.responseText);

						// Loop over elke item in het json bestand
						for (let i = 0; i < response.Values.length; i++) {
							// Als Result minder dan 0 is geef maak een niuew object aan met daarin in isPositive: false
							// Als (in html) isPositive false is word de class 'has-text-danger'
							if (response.Values[i].Result < 0) {
								response.Values[i].procent = {
									isPositive: false
								};
								// Als (in html) isPositive true is word de class 'has-text-success'
							} else {
								response.Values[i].procent = {
									isPositive: true
								};
							}
						}

						self.metrics.data = response;
					})
					.catch(xhr => {
						console.log('Failed to get metrics data', xhr);
						self.error = 'Failed to get metrics data';
					});
			}
		}
	});

	window.activeRootComponent = app;
}
metrics();
